import script from "./soundAndLightAlarmForm.vue?vue&type=script&setup=true&lang=js"
export * from "./soundAndLightAlarmForm.vue?vue&type=script&setup=true&lang=js"

import "./soundAndLightAlarmForm.vue?vue&type=style&index=0&id=0fe66798&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe66798"]])

export default __exports__